// react
import { useContext } from 'react';

// context
import { ContextSpecialCommitments } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableSpecialCommitments } from '../../../../tables/cards/TableSpecialCommitments/TableSpecialCommitments';

export const SpecialCommitments = () => {
	const {
		specialCommitments,
		isLoadingSpecialCommitments,
		paginationSpecialCommitments,
		refetchSpecialCommitments,
	} = useContext(ContextSpecialCommitments);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableSpecialCommitments
						isLoading={isLoadingSpecialCommitments}
						pagination={paginationSpecialCommitments}
						refetchTransactions={refetchSpecialCommitments}
						transactions={specialCommitments}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
